import React, { useState } from "react";
import styles from "./PurchaseDetails.module.css";
// import purchase1 from "../../assets/images/purchase1.png";
// import featureInfo2 from "../../assets/images/featureInfo2.jpg";
const PurchaseDetailsSecondSection = (allData) => {
  const data = allData.data;
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const [zoomedImage, setZoomedImage] = useState(null);

  const openZoom = (imageSrc) => {
    setZoomedImage(imageSrc);
  };

  const closeZoom = () => {
    setZoomedImage(null);
  };
  console.log(data.shipping_1);
  return (
    <div>
      <h6 className={styles.secondSectionTitle}>
        配送先 <span>会員様住所</span>
      </h6>
      <div className={styles.secondSection}>
        {data.shipping_0 &&
          Array.isArray(data.shipping_0) &&
          data.shipping_0.length > 0 &&
          data.shipping_0.map((item, i) => (
            <>
              <div key={i} className="d-flex pt-5">
                <div className={styles.s_product}>
                  <h6>{item.title}</h6>
                </div>
                <div className={styles.s_qtylbl}>
                  <h6>個数</h6>
                </div>
                <div className={styles.s_qty}>
                  <h6>{item?.quantity}</h6>
                </div>
                <div className={styles.image1}>
                  <img
                    src={backend_base + item?.design?.preview_image}
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      openZoom(backend_base + item?.design?.preview_image)
                    }
                    alt={item?.title}
                  />
                </div>
              </div>
              {i < data.length - 1 && <hr className={styles.hr4} />}
            </>
          ))}
      </div>
      {data.shipping_1?.length > 0 && (
        <>
          <h6 className={styles.secondSectionTitle}>
            配送先 <span>別送住所1</span>
          </h6>
          <div className={styles.thirdSection}>
            {data.shipping_1 &&
              Array.isArray(data.shipping_0) &&
              data.shipping_1.length > 0 &&
              data.shipping_1.map((item, i) => (
                <>
                  <div key={i} className="d-flex pt-5">
                    <div className={styles.s_product}>
                      <h6>{item.title}</h6>
                    </div>
                    <div className={styles.s_qtylbl}>
                      <h6>個数</h6>
                    </div>
                    <div className={styles.s_qty}>
                      <h6>{item.quantity}</h6>
                    </div>
                    <div className={styles.image1}>
                      <img
                        src={item.design.preview_image}
                        style={{ cursor: "pointer" }}
                        alt={item.title}
                        onClick={() =>
                          openZoom(backend_base + item?.design?.preview_image)
                        }
                      />
                    </div>
                  </div>
                  {i < data.length - 1 && <hr className={styles.hr4} />}
                </>
              ))}
          </div>
        </>
      )}

      {data.shipping_2.length > 0 && (
        <>
          <h6 className={styles.secondSectionTitle}>
            配送先 <span>別送住所2</span>
          </h6>
          <div className={styles.thirdSection}>
            {data.shipping_2 &&
              Array.isArray(data.shipping_0) &&
              data.shipping_2.length > 0 &&
              data.shipping_2.map((item, i) => (
                <>
                  <div key={i} className="d-flex pt-5">
                    <div className={styles.s_product}>
                      <h6>{item.title}</h6>
                    </div>
                    <div className={styles.s_qtylbl}>
                      <h6>個数</h6>
                    </div>
                    <div className={styles.s_qty}>
                      <h6>{item.quantity}</h6>
                    </div>
                    <div className={styles.image1}>
                      <img
                        src={item.design.preview_image}
                        alt={item.title}
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          openZoom(backend_base + item?.design?.preview_image)
                        }
                      />
                    </div>
                  </div>
                  {i < data.length - 1 && <hr className={styles.hr4} />}
                </>
              ))}
          </div>
        </>
      )}
      {/* Modal for zoomed view */}
      {zoomedImage && (
        <div className={styles.zoomedContainer} onClick={closeZoom}>
          <div className={styles.zoomedOverlay}>
            <img
              src={zoomedImage}
              alt="Zoomed"
              className={styles.zoomedImage}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PurchaseDetailsSecondSection;
